import { render } from "./Provider.vue?vue&type=template&id=e3ab98aa&scoped=true"
import script from "./Provider.vue?vue&type=script&lang=ts"
export * from "./Provider.vue?vue&type=script&lang=ts"

import "./Provider.vue?vue&type=style&index=0&id=e3ab98aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e3ab98aa"

export default script